import { Injectable, effect, inject, signal } from '@angular/core';
import { AuthService } from './auth.service';
import { VendorsService } from '../../features/vendor/services/vendors.service';

@Injectable({ providedIn: 'root' })
export class VendorContextService {
  private readonly auth = inject(AuthService);
  private readonly vendorsService = inject(VendorsService);

  private readonly _vendorName = signal('');

  readonly vendorName = this._vendorName.asReadonly();

  constructor() {
    effect(() => {
      const user = this.auth.user();
      const role = user?.role || '';
      const vendorId = user?.vendor_id || '';

      if (role !== 'vendor' || !vendorId) {
        this._vendorName.set('');
        return;
      }

      this.vendorsService.get(vendorId).subscribe({
        next: (vendor) => this._vendorName.set(vendor.vendor_name || ''),
        error: () => this._vendorName.set(''),
      });
    });
  }
}
